// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"6197":"22ec151e","6571":"ab528392","7008":"ab528392"}[chunkId] + ".chunk.css");